var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodeConduct = function SvgCodeConduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#code_conduct_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.475 3.44A2.12 2.12 0 0 1 3.44 1.475c1.345-.11 3.492-.225 6.56-.225s5.215.115 6.56.225a2.12 2.12 0 0 1 1.965 1.965c.11 1.345.225 3.492.225 6.56s-.115 5.215-.225 6.56a2.12 2.12 0 0 1-1.965 1.965c-1.345.11-3.492.225-6.56.225s-5.215-.115-6.56-.225a2.12 2.12 0 0 1-1.965-1.965c-.11-1.345-.225-3.492-.225-6.56s.115-5.215.225-6.56M16.67 10H3.335M16.508 5.625H3.492M16.509 14.375H3.492"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "code_conduct_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCodeConduct;